import cn from 'clsx'
import { FC } from 'react'

import SelectWithButton from '@/components/ui/select/SelectWithButton'

import { LANGUAGES, PLATFROMS_LANGUAGES } from '@/constants/languages'
import { IOriginal } from '@/types/shotlist.interface'
import { TPlatformValue } from '@/types/uploadForm.interface'

import { ITranslateParams } from '../File'
import { TFilePageRenderState } from '../helpers/getFilePageRenderState'

import FileProcessPanel from './FileProcessPanel'
import TextContainer from './TextContainer'

interface IFileTranslationColumnProps {
	filePageRenderState: TFilePageRenderState
	allPlatformsLanguages: string[]
	handleFirstTranslate: (targetLang: string) => Promise<void>
	setIsChoosingLanguage: (value: boolean) => void
	setTranslatingLang: (value: string) => void
	translatingLang: string | null
	selectedPlatform: TPlatformValue | null
	isTranslation?: boolean
	isTranslateLoading: boolean
	isTranslateError: boolean
	rightRenderLanguage?: IOriginal
	setIsLoading: (value: boolean) => void
	refetch: () => Promise<unknown>
	setRightTab: (value: string) => void
	translationLanguages: string[]
	rightTab: string | null
	originalLang?: string
	setIsTranslateLoading: (value: boolean) => void
	setIsTranslateError: (value: boolean) => void
	lastTranslateParams: ITranslateParams | null
	setLastTranslateParams: (params: ITranslateParams) => void
	isChoosingLanguage: boolean
	targetLang: string | null
	setTargetLang: (value: string) => void
	originalSourceName: string
}

const FileTranslationColumn: FC<IFileTranslationColumnProps> = ({
	filePageRenderState,
	allPlatformsLanguages,
	handleFirstTranslate,
	setIsChoosingLanguage,
	setTranslatingLang,
	translatingLang,
	selectedPlatform,
	isTranslation,
	isTranslateLoading,
	isTranslateError,
	rightRenderLanguage,
	setIsLoading,
	refetch,
	setRightTab,
	translationLanguages,
	rightTab,
	originalLang,
	setIsTranslateLoading,
	setIsTranslateError,
	lastTranslateParams,
	setLastTranslateParams,
	isChoosingLanguage,
	targetLang,
	setTargetLang,
	originalSourceName
}) => {
	if (filePageRenderState === 'only-original') {
		return (
			<section className='flex-[0_1_37.5%]'>
				<SelectWithButton
					onConfirm={handleFirstTranslate}
					availableLangs={allPlatformsLanguages}
					setIsChoosingLanguage={setIsChoosingLanguage}
					text='Translate to'
					isTranslateTo={true}
					startButtonText='Start'
					isCloseButton={false}
					setTranslatingLang={setTranslatingLang}
					classNameBlock='!mt-[44px] !mx-8 !bg-gray-100'
				/>
			</section>
		)
	}

	if (filePageRenderState === 'first-translation-loading') {
		return (
			<FileProcessPanel>
				Translating to{' '}
				{LANGUAGES[translatingLang] || PLATFROMS_LANGUAGES[selectedPlatform]}
			</FileProcessPanel>
		)
	}

	return (
		<section
			className={cn(
				isTranslation || isTranslateLoading || isTranslateError
					? 'flex-[0_1_37.5%]'
					: 'hidden'
			)}
		>
			<TextContainer
				key={rightRenderLanguage?.id || 'translation'}
				id={rightRenderLanguage?.id}
				type='translation'
				textArray={rightRenderLanguage?.content?.split('\n\n') || []}
				setIsLoading={setIsLoading}
				onDelete={refetch}
				onTranslate={refetch}
				setTab={setRightTab}
				language={translationLanguages}
				tab={rightTab}
				isTranslateLoading={isTranslateLoading}
				setIsTranslateLoading={setIsTranslateLoading}
				setRightTab={setRightTab}
				originalLang={originalLang}
				isTranslateError={isTranslateError}
				setIsTranslateError={setIsTranslateError}
				lastTranslateParams={lastTranslateParams}
				setLastTranslateParams={setLastTranslateParams}
				isChoosingLanguage={isChoosingLanguage}
				setIsChoosingLanguage={setIsChoosingLanguage}
				targetLang={targetLang}
				setTargetLang={setTargetLang}
				originalSourceName={originalSourceName}
				showChooser={true}
			/>
		</section>
	)
}

export default FileTranslationColumn
